<template>
  <div class="ApproveItem">
    <approveLine
              :itemId="itemId"
              :approveType="approveType"
            ></approveLine>
    <el-form
      :model="approveForm"
      :rules="rules"
      ref="approveForm"
      label-width="100px"
      class="contactsForm"
    >
      <div class="AddSupplierAContent">
        <el-row>
          <el-col :span="20">
            <el-form-item label="审批结果" prop="status" label-width="140px">
              <el-radio-group
                v-model="approveForm.status"
                style="display: flex"
              >
                <el-radio
                  v-for="item in options"
                  :label="item.value"
                  :key="item.value"
                  style="margin: 14px 20px"
                  >{{ item.label }}</el-radio
                >
              </el-radio-group>
              <!-- <el-select
                v-model="approveForm.status"
                filterable
                default-first-option
                placeholder="请选择"
                style="width: 60%"
              >
                <el-option
                  :label="item.label"
                  :value="item.value"
                  v-for="(item, index) in options"
                  :key="index"
                ></el-option>
              </el-select> -->
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="subapproveType === 'TotalContract' && islastApproveUser">
          <el-col :span="20">
            <el-form-item label="项目部" label-width="140px">
              <el-cascader
                v-model="deptIds"
                :options="subDeptList"
                :props="defaultProps"
                @change="handleChange"
                placeholder="-请选择-"
                @active-item-change="handleChange"
                change-on-select
                style="width: 60%"
              ></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="approveType === 'GENERAL_CONTRACT' && islastApproveUser">
          <el-col :span="20">
            <el-form-item label="项目经理" label-width="140px">
              <el-select
                v-model="approveForm.chargeUserId"
                placeholder="-请选择-"
                filterable
                style="width: 60%"
              >
                <el-option
                  :label="item.displayName"
                  :value="item.id"
                  v-for="(item, index) in ProjectGMList"
                  :key="index"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="审批意见" label-width="140px" prop="opinion">
              <el-input
                type="textarea"
                :rows="4"
                placeholder="请输入内容"
                v-model="approveForm.opinion"
                maxlength="200"
                size="medium"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
    <div class="bottomBtn">
      <el-button type="primary" @click="confirmApprove('approveForm')"
        >审 批</el-button
      >
      <!-- <el-button type="info" @click="isDialogShow = false">取 消</el-button> -->
    </div>
  </div>
</template>

<script>
import {
  getCurrentApproveListService, //查询当前列表
  confirmSupplierApproveServices, //提交审批
} from "@/services/approveServices";
import {
  getProjectGMListService, //获取项目经理列表
  getsubDeptService, //获取项目部二级项目级联列表
  getDeptListService, //根据组织获取项目部一级数据下拉列表
} from "@/services/sysSettingService";
import {
  saveProjectUser, //审批保存项目经理
} from "@/services/allContractServices";
import { getRouteIdByType } from "./approve.js";
import approveLine from "./ApproveHistoryLine"; //历史审批流程

export default {
  name: "ApproveItem",
  props: {
    approveType: {
      //审批类型
      type: String,
      default: "",
    },
    subapproveType: {
      //审批子类型
      type: String,
      default: "",
    },
    itemId: {
      //审批对象id
      type: Number,
      default: 0,
    },
  },
  components:{
    approveLine
  },
  data() {
    return {
      islastApproveUser: false, //标志是否为最后一及审批
      subDeptList: [], //项目部下拉列表数据
      ProjectGMList: [], //项目经理下拉列表数据
      deptIds: [],
      //审批form
      approveForm: {
        status: 3,
        chargeUserId: null, // 项目经理id
        itemId: 0, //对应审批对象id
        approveUserId: "", //审批人id
        deptId: "", //部门id
        opinion: "", //审批意见
        type: this.approveType, //审批类型
      },
      options: [
        {
          label: "通过",
          value: 3,
        },
        {
          label: "驳回",
          value: 4,
        },
      ],
      defaultProps: {
        label: "name",
        value: "id",
        lazy: true,
        lazyLoad(node, resolve) {
          const param = {};
          if (undefined != node.value) {
            param.deptId = node.value;
            getsubDeptService(param).then((res) => {
              if (res.code == 10000000) {
                const nodes = res.data;
                nodes.forEach((item) => {
                  item.leaf = item.isLeaf == 1;
                });
                resolve(nodes);
              } else {
                this.$message.error(res.msg);
              }
            });
          }
        },
      },
      rules: {
        status: [
          { required: true, message: "请选择审批结果", trigger: "blur" },
        ],
        opinion: [
          { required: true, message: "请输入审批意见", trigger: "blur" },
        ],
      },
    };
  },
  watch: {
    itemId(value) {
      if (value !== 0&&value) {
        this.getApproveList(value);
      }
    },
  },
  mounted() {
    if (this.itemId !== 0&&this.itemId) {
      this.getApproveList(this.itemId);
    }
  },
  methods: {
    //查询当前审批流
    getApproveList(id) {
      let param = {
        id: id,
        type: this.approveType,
      };
      getCurrentApproveListService(param)
        .then((res) => {
          if (res.code == 10000000) {
            this.approveForm = { ...res.data };
            this.approveForm.status = 3;
            this.islastApproveUser = res.data.lastProcess; //是否为最后一级审批
            if (
              this.approveType === "GENERAL_CONTRACT" &&
              this.islastApproveUser
            ) {
              this.getProjectClubList(0); //获取部门下拉列表
              this.getProjectGMList();
            }
          } else {
            this.$message.warning(res.msg);
            this.goBackApprove();
          }
        })
        .catch((error) => {});
    },
    goBackApprove() {
      let routeId = getRouteIdByType(this.approveType);
      this.bus.$emit("tabClose", routeId);
      this.bus.$emit("navMenuChange", {
        routeId: "pendingApproval",
      });
    },
    //提交审批
    confirmApprove(formName) {
      let param = this.approveForm;
      if (param.status === 3) {
        if (this.approveType === "GENERAL_CONTRACT" && this.islastApproveUser) {
          if (0 == param.deptId || param.deptId == "") {
            this.$alert("请选择项目部", "提示", {
              confirmButtonText: "确定",
            });
            return;
          }
          if (!param.chargeUserId) {
            this.$alert("请选择项目经理", "提示", {
              confirmButtonText: "确定",
            });
            return;
          }
        }
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认审批吗？", "提示", {
            confirmButtonText: "确认",
          }).then(() => {
            confirmSupplierApproveServices(param)
              .then((res) => {
                if (res.code == "10000000") {
                  if (
                    param.status === 3 &&
                    this.approveType === "GENERAL_CONTRACT" &&
                    this.islastApproveUser
                  ) {
                    //总包合同保存项目经理
                    this.saveProjectUser();
                  } else {
                    this.$message.success("审批完成");
                    this.$emit("finishApprove");
                  }
                } else if (res.code > 10000000) {
                  this.$alert(res.msg, "提示", {
                    confirmButtonText: "确定",
                  });
                } else {
                  this.$message.error("系统异常");
                }
              })
              .catch((error) => {
                this.$message.error("系统异常");
              });
          });
        }
      });
    },

    //保存项目经理
    saveProjectUser() {
      let param = {};
      param.chargeUserId = this.approveForm.chargeUserId;
      param.generalContractId = this.approveForm.itemId;
      saveProjectUser(param)
        .then((res) => {
          if (res.code == "10000000") {
            this.$message.success("审核及保存项目经理完成");
            this.$emit("finishApprove");
          } else if (res.code > 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$message.error("系统异常");
          }
        })
        .catch((error) => {
          this.$message.error("系统异常");
        });
      console.log("保存项目经理");
    },
    //获取项目部下拉列表数据
    getProjectClubList(deptId) {
      let reqParam = {
        pid: deptId,
        orgId: sessionStorage.getItem("orgId"),
      };
      getDeptListService(reqParam).then(
        (res) => {
          if (res.code == 10000000) {
            // this.total = res.total;
            this.subDeptList = res.data;
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        },
        (err) => {
          this.$alert("系统异常", "提示", {
            confirmButtonText: "确定",
          });
        }
      );
    },

    //获取审批列表项目经理下拉框数据
    getProjectGMList() {
      let param = {
        deptId: this.approveForm.deptId,
        jobId: 0,
      };
      getProjectGMListService(param)
        .then((res) => {
          if (res.code == 10000000) {
            this.ProjectGMList = res.data;
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((error) => {});
    },
    //部门改变时获取数据
    handleChange(value) {
      let len = value.length;
      this.approveForm.deptId = value[len - 1];
      if( this.approveForm.chargeUserId)
      this.approveForm.chargeUserId=null
      // this.approveForm.chargeUserId = "";
      this.getProjectGMList();
      
    },
    setRowClassName({ row, rowIndex }) {
      if (row.isOverTime != 0) {
        return "overTimeMark";
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";
.ApproveItem {
  background-color: white;
  margin-top: 40px;
  .el-input {
    width: 100%;
    padding-bottom: 12px;
  }
  .buttons {
    margin-top: 20px;
    margin-left: 60px;
  }
  .bottomBtn {
    left: 36%;
    position: fixed;
    bottom: 30px;
  }
}
</style>
